import { render } from "./DistriDashTiles.vue?vue&type=template&id=b16c65f6&scoped=true"
import script from "./DistriDashTiles.vue?vue&type=script&lang=js"
export * from "./DistriDashTiles.vue?vue&type=script&lang=js"

import "./DistriDashTiles.vue?vue&type=style&index=0&id=b16c65f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b16c65f6"]])

export default __exports__